/**
 * Static dropdown vocabularies for the Purchasing → ASN filter panel.
 *
 * CR-6449: shared by the supplier layout (`ASNFilterSupplierLayout`) and the
 * customer layout (`ASNFilterSections`) so the two views can never drift on
 * the status / courier option sets.
 */
export interface ASNFilterOption {
  value: string;
  label: string;
}

/** ASN status options — mirrors AdvancedShippingNotice.STATUS_CHOICES. */
export const ASN_STATUS_OPTIONS: ASNFilterOption[] = [
  { value: 'created', label: 'Created' },
  { value: 'submitted', label: 'Submitted' },
  { value: 'in_transit', label: 'In Transit' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'received', label: 'Received' },
  { value: 'cancelled', label: 'Cancelled' },
];

/** Courier options. */
export const ASN_COURIER_OPTIONS: ASNFilterOption[] = [
  { value: 'fedex', label: 'FedEx' },
  { value: 'ups', label: 'UPS' },
  { value: 'dhl', label: 'DHL' },
  { value: 'tnt', label: 'TNT' },
  { value: 'dpd', label: 'DPD' },
  { value: 'other', label: 'Other' },
];

/**
 * Courier delivery status options — the FALLBACK only. The live list comes
 * from `/purchasing/asns/filter-options/` (see `useASNFilterOptions`), which
 * serves `AdvancedShippingNotice.COURIER_DELIVERY_STATUS_CHOICES` verbatim;
 * this copy is shown until that call answers or if it fails. Keep it equal
 * to the model vocabulary: pending / in_transit / out_for_delivery /
 * delivered / exception / unknown.
 */
export const ASN_COURIER_STATUS_OPTIONS: ASNFilterOption[] = [
  { value: 'pending', label: 'Pending' },
  { value: 'in_transit', label: 'In Transit' },
  { value: 'out_for_delivery', label: 'Out for Delivery' },
  { value: 'delivered', label: 'Delivered' },
  { value: 'exception', label: 'Exception' },
  { value: 'unknown', label: 'Unknown' },
];

/**
 * Supplier Type options — internal / external relative to the customer
 * organisation in scope (backend `supplier_type`, core.internal_suppliers).
 * Customer view only; same values and labels as the Dashboard.
 */
export const ASN_SUPPLIER_TYPE_OPTIONS: ASNFilterOption[] = [
  { value: 'internal', label: 'Internal Suppliers' },
  { value: 'external', label: 'External Suppliers' },
];

/** Quick-select date chips shown in the Date Range section. */
export const ASN_QUICK_SELECT_CHIPS: ASNFilterOption[] = [
  { value: '3months', label: 'Last 3 months' },
  { value: '12months', label: 'Last 12 months' },
  { value: 'custom', label: 'Custom' },
];
